import styled from "styled-components";

export const Container = styled.div`
  background-image: radial-gradient(
    circle at 50% 14em,
    #313264 0%,
    #00023b 60%,
    #00023b 100%
  );
  background-repeat: no-repeat;
  flex: 1;
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;

  .logoMenuLegal {
    align-self: center;
  }
  .forgetPasswordLink {
    color: #999;
    margin-bottom: 10px;
    width: 100%;
    text-align: right;
  }
`;

export const LoginContainer = styled.form`
  background: #fff;
  display: flex;
  border-radius: 20px;
  padding: 50px;
  flex-direction: column;
  width: 300px;
  text-align: center;
`;
